import { ChangeDetectorRef, Component, OnInit, ViewChild } from '@angular/core';
import { PaginationOptions, ProductExcelRow, QueryFilter, SPProductFilterOptions, SpProductOrLocationExportPayload, groupByProducts, products } from '../types/solution-participation-types';
import { ActivatedRoute, Router } from '@angular/router';
import { FiltersService } from 'src/app/core/services/filters.service';
import { MatPaginator, MatPaginatorIntl, PageEvent } from '@angular/material/paginator';
import { UntypedFormControl } from '@angular/forms';
import { skip, Subscription } from 'rxjs';
import { MatCheckbox } from '@angular/material/checkbox';
import { MixpanelService } from 'src/app/core/services/mixpanel.service';
import { ContractModel } from 'src/app/global/contract-filter-model';
import { SolutionParticipationService } from '../service/solution-participation.service';
import { SpExcelExportService } from '../service/sp-excelexport.service';
import { CurrencyUomService } from 'src/app/core/services/currency-uom.service';


@Component({
    selector: 'app-product-details-drilldown-view',
    templateUrl: './product-details-drilldown-view.component.html',
    styleUrls: ['./product-details-drilldown-view.component.scss'],
    standalone: false
})
export class ProductDetailsDrilldownViewComponent implements OnInit {

  private currencySubscription: Subscription | undefined;
  productData: groupByProducts[] = [];
  productDataPaginated: groupByProducts[] = [];

  productName: string | undefined;
  productCode: string | undefined;
  solutionGroupName: string | undefined;

  @ViewChild(MatPaginator) paginator!: MatPaginator;
  searchByLocationInput = new UntypedFormControl;

  filters: ContractModel | undefined;
  filtersSubscription: Subscription | undefined;

  isLoading: boolean = false;

  filteredData: groupByProducts[] = [];

  // Define the sort direction objects to store the direction for each column
  sortDirections: { [key: string]: string } = {
    sales: 'desc',
    cases: 'desc'
  };
  sortBy: string = 'sales';
  sortDirection = 'desc';

  exportAll: boolean = false;
  isGroupRowChecked:boolean = false;
  rowSelection: boolean[] = [];

  excelData: ProductExcelRow[] =[];
  allRowsSelected: boolean = false;
  byDefaultSelectAllRows:boolean=false;

  productSelectedAdvancedFilters: SPProductFilterOptions = {
    "accountNumber": [],
    "accountName": [],
    "country": [],
    "state": [],
    "city": [],
    "zipCode": [],
    "productSku": [],
    "brand": []
  };
  productAdvancedFiltersSubscription: Subscription| undefined;
  data!: products;
  totalRecords: number = 0;
  paginationOptions: PaginationOptions = {
    limit: 10,
    page: 1,
    sortBy: '',
    sortOrder: '',
    tabSelected:''
  };
  productExcelExportPayload!: SpProductOrLocationExportPayload;
  selectedAccountIds: string[] = [];
  notSelectedAccountIds: string[] = [];
  isDownloadingFile:boolean = false;
  currencyCode:string = '';

  constructor(
    private _filterService: FiltersService,
    private _route: ActivatedRoute,
    private _router: Router,
    private _mixpanelService: MixpanelService,
    private _solutionParticipation : SolutionParticipationService,
    private _spExcelexportService:SpExcelExportService,
    private _currencyUomService: CurrencyUomService,
    private _cdr: ChangeDetectorRef
  ) { }

  ngOnInit(): void {
    this.filtersSubscription = this._filterService.selectedFiltersObservable.subscribe(f => this.filters = f);
    this.productAdvancedFiltersSubscription = this._solutionParticipation.getProductDetailsAdvancedFilters().subscribe(advFilter => this.productSelectedAdvancedFilters = advFilter);
    if (this.filters?.period != undefined) {
      this._route.queryParams.subscribe(p => {
        this.productName = p['productName'],
        this.productCode = p['productCode'],
        this.solutionGroupName = p['solutionGroup'];
        this.isGroupRowChecked = JSON.parse(p['isProductChecked']);
        this.byDefaultSelectAllRows = this.isGroupRowChecked;

      this.productExcelExportPayload = this._solutionParticipation.getSpProductorLocationExportPayload();
      this.productExcelExportPayload.contractModel = this.filters;
        // Clear the Search Term
        this.productExcelExportPayload.searchTerm = '';
        this.upDateQueryFilter('SOLUTION', this.solutionGroupName ?? '', '=', 'And');
        this.upDateQueryFilter('PRODUCTCODE', this.productCode ?? '', '=', 'And');

      });

      if (this.productName === undefined) {
        this._router.navigate(['/solution-participation-groupBy-products'], {
          queryParams: {
            groupBy: 'product',
            solutionGroup: this.solutionGroupName,
            isProductChecked:false,
          }
        });
      }

      this.getData(this.productCode,this.productSelectedAdvancedFilters);
      this.getCurrency();
      this.currencySubscription = this._currencyUomService.selectedCurrency$.pipe(skip(1)).subscribe(async () => {
        this.currencyCode = '';
        this._currencyUomService.setCurrencyLoading(true);

        this.getData(this.productCode,this.productSelectedAdvancedFilters);

        this._currencyUomService.setCurrencyLoading(false);
        this.getCurrency();
        this._cdr.detectChanges();
      });
    }
    else {
      alert('Please apply filters before navigating to Solution Participation')
      this._router.navigate(['/filter']);
    }
  }


  async getData(product: string | undefined,advProductFilters: SPProductFilterOptions) {
    this.isLoading = true;
    let transformedData: groupByProducts[] = [];
    this.data = await this._solutionParticipation.getByProductData(this.solutionGroupName, advProductFilters,this.paginationOptions,this.productCode,true);
    this.totalRecords = this.data?.totalCount;
    transformedData = this.data.products;

    this.isLoading = false;
    window.scrollTo(0, 0);
    this.productData = this.data.products;
    this.filteredData = this.data.products;
    this.productCode = this.data.products[0].productCode;
    this.productName = this.data.products[0].productName;
    this.paginate(0, this.paginator.pageSize);
  }


  ngOnDestroy(): void {
    if (this.filtersSubscription) {
      this.filtersSubscription.unsubscribe();
    }
    if (this.productAdvancedFiltersSubscription) {
      this.productAdvancedFiltersSubscription.unsubscribe();
    }
    if (this.productExcelExportPayload && this.productExcelExportPayload.queryFilters) {
      this.productExcelExportPayload.queryFilters = [];
    }
    this.currencySubscription?.unsubscribe();
  }

  async onPageChange(event : PageEvent){
    await this.updatePageData(event.pageIndex, event.pageSize);
  }

  async updatePageData(pageIndex: number, pageSize: number) {
    this.paginationOptions = {
      ...this.paginationOptions,
      page: pageIndex + 1,
      limit: pageSize
    };
    await this.getData(this.productCode,this.productSelectedAdvancedFilters);
  }

  paginate(pageIndex: number, pageSize: number) {
    let startIndex = pageIndex * pageSize;
    let endIndex = (pageIndex * pageSize) + pageSize;
    this.productDataPaginated = this.filteredData.slice(startIndex, endIndex);
    if (this.productDataPaginated.length > 0 && this.byDefaultSelectAllRows){
      this.byDefaultSelectAllRows = false;
      this.selectAllRows();
    }
  }


  async toggleSortDirection(column: string) {
    // Toggle the sort direction for the specified column
    this.sortDirections[column] = this.sortDirections[column] === 'asc' ? 'desc' : 'asc';

    this.sortBy = column;
    this.sortDirection = this.sortDirections[column];

        this.paginationOptions = {
      ...this.paginationOptions,
      sortBy: this.getSortedColumnName(this.sortBy),
      sortOrder: this.sortDirection,
    };
    await this.getData(this.productCode,this.productSelectedAdvancedFilters);

    this._mixpanelService.track('Product Details Summary Row Drilldown - Header Sort Clicked', {
      'Column Name': column,
      'Page Name': 'Solution Participation - Product Details Drilldown',
    });
  }

  selectAllRows() {
    this.allRowsSelected = !this.allRowsSelected;
    for (let i = 0; i < this.data.totalCount; i++) {
      this.rowSelection[i] = this.allRowsSelected;
      this.notSelectedAccountIds = this.selectedAccountIds = []; // Clear the not selected Account Number when all rows are selected.
    }
    this.allRowsSelected = this.isAllSelected();
  }

  onCheckboxChange(event: MatCheckbox,row:any,rowNumber:number): void {
    const pageSize = this.paginator.pageSize;
    const pageIndex = this.paginator.pageIndex;
    rowNumber = (pageSize*pageIndex) + rowNumber;
    this.rowSelection[rowNumber] = event.checked;
    const selectedSet = new Set(this.selectedAccountIds);
    const notSelectedSet = new Set(this.notSelectedAccountIds);

    if (event.checked) {
        selectedSet.add(row.accountInfo[0].accountNumber);
        notSelectedSet.delete(row.accountInfo[0].accountNumber);
    } else {
        selectedSet.delete(row.accountInfo[0].accountNumber);
        notSelectedSet.add(row.accountInfo[0].accountNumber);
    }
    this.selectedAccountIds = Array.from(selectedSet);
    this.notSelectedAccountIds = Array.from(notSelectedSet);
    this.allRowsSelected = this.isAllSelected();
  }

  isAllSelected() {
    return !this.rowSelection.some(value => value === false);
  }

  async exportAllToExcel() {
    if(!this.rowSelection.includes(true)){
      window.alert('Please select at least one product to export.');
      return;
    }
    if(!this.isAllSelected())
      this.applyAccountIdFiltersForExport();

    this.isDownloadingFile = true;
    const currentDate = new Date().toISOString().slice(0, 19).replace(/[-T:/]/g, '');
    const fileName = `EBR__Product_Details_${currentDate}_Solution.xlsx`;

    let initializeDownload = true;
    const fileData = await this._solutionParticipation.DownloadExcel(this.productExcelExportPayload).then(response => {
      if (response) {
        const { data } = response;
        return data;
      }
      initializeDownload = false;
      return null;
    }).catch(error => {
      initializeDownload = false;
      this.isDownloadingFile = false;
      console.log(JSON.stringify(error));
    });

    if (initializeDownload && fileData.size > 0) {
      this._spExcelexportService.executeBrowserDownload(fileData, fileName);
      this._mixpanelService.track('Solution Participation - Product Details - Export Button Clicked', {
      'No Of Records Downloaded and FileName': `${fileData.size} and ${fileName}`,
      'Page Name': 'Solution Participation - Product Details',
    });
    }else{
        alert('No data found to export.');
      }
    this.isDownloadingFile = false;

    // Clear the selected ACCOUNTNUMBER  after export.
    this.productExcelExportPayload.queryFilters = this.productExcelExportPayload.queryFilters?.filter(filter =>
      !filter.columnFilters.hasOwnProperty('ACCOUNTNUMBER')
    );
  }


  getCurrency() {
     this.currencyCode = this._currencyUomService.getCurrencyCode();
  }

  /// This method returns the column name based on the sortColumn parameter
  /// It is used to map the sort column to the actual data field name in BE Database.
  getSortedColumnName(sortColumn:string): string {
    switch (sortColumn) {
      case 'sales':
        return 'TotalSalesAmount';
      case 'cases':
        return 'TotalSalesQuantity';
      default:
        return 'TotalSalesQuantity';
    }
  }

  applyAccountIdFiltersForExport() {
    if (this.selectedAccountIds.length > 0) {
      this.upDateQueryFilter('ACCOUNTNUMBER', this.selectedAccountIds, 'In','And');
    } else if (this.notSelectedAccountIds.length > 0) {
      this.upDateQueryFilter('ACCOUNTNUMBER', this.notSelectedAccountIds, 'Not In','And');
    }
  }

  upDateQueryFilter(
    columnName: string,
    filterValue: any,
    filterOperation: "In" | "Not In" | "Equals" | "ILike" | "=" | "!=",
    logicalOperator: "And" | "Or"
  ) {

    this._spExcelexportService.upsertQueryFilter(
      this.productExcelExportPayload,
      columnName,
      filterValue,
      filterOperation,
      logicalOperator);
  }
}
